import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import Rejected from "./Rejected";

const RejectedLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Rejected Counselors" />
      <Rejected url={"counselors/unapproved"} />
    </MasterLayout>
  );
};
export default RejectedLayout;
